/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Cases_By_Type_DescriptionInputs */

const en_dashboard_cases_by_type_description = /** @type {(inputs: Dashboard_Cases_By_Type_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case volume by category for the selected creation period.`)
};

const pt_br2_dashboard_cases_by_type_description = /** @type {(inputs: Dashboard_Cases_By_Type_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume de casos por categoria no período de criação selecionado.`)
};

/**
* | output |
* | --- |
* | "Case volume by category for the selected creation period." |
*
* @param {Dashboard_Cases_By_Type_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_cases_by_type_description = /** @type {((inputs?: Dashboard_Cases_By_Type_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Cases_By_Type_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_cases_by_type_description(inputs)
	return pt_br2_dashboard_cases_by_type_description(inputs)
});